export const OfferStatus = {
  Pending: 'Pending',
  Rejected: 'Rejected',
  Accepted: 'Accepted',
  Draft: 'Draft',
  InProgress: 'In Progress',
};

export const OfferBuyerTerms = {
  repairs: 'repairs',
  walkthrough: 'walkthrough',
  other: 'other',
  Repairs: 'Repairs',
  Walkthrough: 'Walkthrough',
  BuyerCommission: 'buyerCommission',
  Other: 'Other',
  Custom: 'Custom',
};

export const OfferBuyerConditions = {
  financing: 'financing',
  inspection: 'inspection',
  Financing: 'Financing',
  Inspection: 'Inspection',
  other: 'other',
  Sale: 'Sale',
  sale: 'sale',
  Custom: 'Custom',
  AccessAndReview: 'Condo Access & Review',
};

export const OfferBuyerConditionNames = {
  Financing: 'Subject to financing',
  Inspection: 'Subject to inspection',
  Sale: 'Subject to Sale of Buyer\'s Property',
  AccessAndReview: 'Subject to Condo Documents Access & Review',
};

export const MAP_CONDITION_NAME_TO_TYPE = {
  [OfferBuyerConditionNames.Financing]: OfferBuyerConditions.financing,
  [OfferBuyerConditionNames.Inspection]: OfferBuyerConditions.inspection,
  [OfferBuyerConditionNames.Sale]: OfferBuyerConditions.sale,
  [OfferBuyerConditionNames.AccessAndReview]: OfferBuyerConditions.AccessAndReview,
};

export const OfferBuyerTrackEventHeadings = {
  Seller: 'Bode_Seller',
  Bode: 'Bode_Buyer',
  Agent: 'Bode_Agent',
  Repliers: 'MLS',
  Bridge: 'MLS',
  BridgeRAE: 'MLS',
  DDF: 'MLS',
};

export const OfferConditionStatus = {
  Satisfied: 'Satisfied',
  NotSatisfied: 'Not Satisfied',
};

export const OfferTermAndConditionsKey = {
  buyerTerms: 'buyerTerms',
  buyerConditions: 'buyerConditions',
  sellerConditions: 'sellerConditions',
};

export const OfferRole = {
  Buyer: 'Buyer',
  Seller: 'Seller',
};

export const OfferBodeUserType = {
  Agent: 'Bode_Agent',
  Buyer: 'Bode_Buyer',
};

export const OfferFlowStage = {
  Draft: 'draft',
  View: 'view',
  Historical: 'historical',
  Submit: 'submit',
  Accept: 'accept',
  Reject: 'reject',
  SubmitList: 'submitList',
  Counter: 'counter',
  Submitted: 'submitted',
};

export const OfferFlowStep = {
  AgentOfferType: 'agentOfferType',
  ContactDetails: 'contactDetails',
  Price: 'price',
  Timing: 'timing',
  Terms: 'terms',
  Review: 'review',
};

export const HTTPStatusCode = {
  NotFound: 404,
  Unauthorized: 401,
  InternalServerError: 500,
};

export const OfferErrorsByStatusCode = {
  [HTTPStatusCode.NotFound]: 'Offer not found. Please load the Offers page again.',
  [HTTPStatusCode.Unauthorized]: 'You are not authorised to access this offer',
  [HTTPStatusCode.InternalServerError]: 'Something went wrong. Please load the Offers page again.',
};

export const OfflineOfferTrackEventHeadings = {
  Seller: 'Bode Seller',
  Bode: 'Bode Buyer',
  Agent: 'Bode Agent',
};

export const OfferDepositLocationTypes = {
  Bode: 'Bōde\'s trust account',
  Brokerage: 'My Brokerage\'s trust account',
  Other: 'Other',
};
